var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHomeIcon = function SvgHomeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69,
    height: 68,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#home-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    x: 4.5,
    y: 3,
    fill: "#E6E6E6",
    rx: 30
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#979797",
    fillRule: "evenodd",
    d: "M49.5 27.62 37.868 15.988a5 5 0 0 0-7.071 0L19.5 27.285v24.191h11.667v-10a3.333 3.333 0 1 1 6.666 0v10H49.5zm-16.346-9.275-10.32 10.32v19.478h5v-6.667a6.667 6.667 0 0 1 13.333 0v6.667h5V29L35.51 18.345a1.667 1.667 0 0 0-2.357 0",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "home-icon_svg__a",
    width: 68,
    height: 68,
    x: 0.5,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8260_153"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_8260_153",
    result: "shape"
  })))));
};
export default SvgHomeIcon;